import { isDateString } from "utils/dateUtils.js";

const commonFilters = (filterValue) => ({
    fileNo: filterValue,
    client: {
        lastName: filterValue,
        firstName: filterValue,
        middleName: filterValue,
        address: filterValue,
        city: filterValue,
        homePhone: filterValue,
        email: filterValue,
        ssn: filterValue,
        ...(isDateString(filterValue) ? { birthDate: filterValue } : {}),
    },
});

export const Immigration = (filterValue) => {
    if (!filterValue) {
        return {};
    }

    const filters = {
        isQuickSearch: true,
        quickSearchValue: filterValue,
    };

    return filters;
};

export const Taxes = (filterValue) => {
    return filterValue
        ? {
              ...commonFilters(filterValue),
          }
        : {};
};

export const Crime = (filterValue) => {
    return filterValue
        ? {
              ...commonFilters(filterValue),
          }
        : {};
};

export const Injury = (filterValue) => {
    return filterValue
        ? {
              ...commonFilters(filterValue),
          }
        : {};
};

export const Family = (filterValue) => {
    return filterValue
        ? {
              ...commonFilters(filterValue),
          }
        : {};
};
